/** ISO 3166-1 alpha-2 codes available for sales country filtering (aligned with backend). */
const SALES_FILTER_COUNTRY_CODES = [
  'AT', 'AU', 'BE', 'BG', 'CA', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB',
  'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'JP', 'LI', 'LT', 'LU', 'LV', 'MT', 'NL', 'NO', 'PL',
  'PT', 'RO', 'SE', 'SI', 'SK', 'US',
] as const;

export type SalesFilterCountryCode = (typeof SALES_FILTER_COUNTRY_CODES)[number];

export function getSalesFilterCountryOptions(): { code: string; label: string }[] {
  const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
  return [...SALES_FILTER_COUNTRY_CODES]
    .map((code) => ({
      code,
      label: displayNames.of(code) ?? code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'en'));
}
